"use strict";
/**
 * The main module of `latex-utensils`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.latexParser = exports.latexLogParser = exports.bibtexParser = void 0;
/** */
const latexParser = require("./latex/latex_parser");
exports.latexParser = latexParser;
const bibtexParser = require("./bibtex/bibtex_parser");
exports.bibtexParser = bibtexParser;
const latexLogParser = require("./latex_log/latex_log_parser");
exports.latexLogParser = latexLogParser;
//# sourceMappingURL=main.js.map